import React from 'react';
import { CardCvcElement } from '@stripe/react-stripe-js';

import { VpStripeInput } from '../..';

export const StripeCardCvcInput = () => {
  return (
    <VpStripeInput
      stripeElement={CardCvcElement}
      options={{
        placeholder: 'CVC'
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/stripe-elements/StripeCardCvcInput.jsx